import { get, del } from "aws-amplify/api";
import { getUrl } from "aws-amplify/storage";
import { fetchAuthSession } from "aws-amplify/auth";

const apiName = "vc-proposal-generator";
const path = "/proposal-generator/";

async function getAuthHeaders() {
  try {
    const session = await fetchAuthSession();
    if (session.tokens?.idToken) {
      return {
        Authorization: `Bearer ${session.tokens.idToken.toString()}`,
      };
    }
    return {};
  } catch (error) {
    console.log("Error getting auth headers:", error);
    return {};
  }
}

export async function getSubmissions(section = 1) {
  const authHeaders = await getAuthHeaders();
  let response = await get({
    apiName,
    path: path + "get-data",
    options: {
      headers: {
        ...authHeaders,
        type: "all",
        section: `${section}`,
      },
    },
  }).response;

  const result = await response.body.json();
  return result;
}

export async function getAdditionalSubmissions(section = 1, lastkey = "") {
  const authHeaders = await getAuthHeaders();
  let response = await get({
    apiName,
    path: path + "get-data",
    options: {
      headers: {
        ...authHeaders,
        type: "additionalSubmissions",
        section: `${section}`,
        lastkey: lastkey,
      },
    },
  }).response;

  const result = await response.body.json();
  return result;
}

export async function getS3FormsFileUrl(FilePath, exp = 60) {
  if (
    (typeof FilePath === "string" || FilePath instanceof String) &&
    FilePath !== ""
  ) {
    let result = await getUrl({
      path: FilePath,
      options: {
        expiresIn: exp,
      },
    });
    return result.url;
  } else {
    return null;
  }
}

export async function getProposalTypes() {
  // types || devtypes
  const authHeaders = await getAuthHeaders();
  let response = await get({
    apiName,
    path: path + "get-data",
    options: {
      headers: {
        ...authHeaders,
        type: process.env.NODE_ENV === "production" ? "types" : "devtypes",
        // type: process.env.NODE_ENV !== "production" ? "types" : "devtypes",
      },
    },
  }).response;

  // The API returns the response as-is, so we just return what we get
  const result = await response.body.json();
  return result;
}

export async function getRegistrationTypes() {
  const authHeaders = await getAuthHeaders();
  let response = await get({
    apiName,
    path: path + "get-data",
    options: {
      headers: {
        ...authHeaders,
        type: "registrations",
      },
    },
  }).response;

  const result = await response.body.json();
  return result;
}

export async function getRegistrationCategoryTypes() {
  const authHeaders = await getAuthHeaders();
  let response = await get({
    apiName,
    path: path + "get-data",
    options: {
      headers: {
        ...authHeaders,
        type: "registrationcategories",
      },
    },
  }).response;

  const result = await response.body.json();
  return result;
}

export async function getCustomInfo() {
  const authHeaders = await getAuthHeaders();
  let response = await get({
    apiName,
    path: path + "get-data",
    options: {
      headers: {
        ...authHeaders,
        type: "custom",
      },
    },
  }).response;

  const result = await response.body.json();
  return result;
}

export async function getLogos() {
  const authHeaders = await getAuthHeaders();
  let response = await get({
    apiName,
    path: path + "get-data",
    options: {
      headers: {
        ...authHeaders,
        type: "logo",
      },
    },
  }).response;

  const result = await response.body.json();
  return result;
}

export async function getDocumentsTree() {
  const authHeaders = await getAuthHeaders();
  let response = await get({
    apiName,
    path: path + "get-data",
    options: {
      headers: {
        ...authHeaders,
        type: "docs",
      },
    },
  }).response;

  const result = await response.body.json();
  return result;
}

export async function deleteSubmissions(dateTime, username) {
  const authHeaders = await getAuthHeaders();
  let response = await del({
    apiName,
    path: path,
    options: {
      headers: {
        ...authHeaders,
      },
      body: {
        dateTime: dateTime,
        username: username,
      },
    },
  }).response;

  const result = await response.body.json();
  return result;
}

export async function getFile(dateTime, username, section = 0) {
  const authHeaders = await getAuthHeaders();
  let response = await get({
    apiName,
    path: path + "get-file",
    options: {
      headers: {
        ...authHeaders,
        dateTime: dateTime,
        username: username,
        section: `${section}`,
      },
    },
  }).response;

  const result = await response.body.json();
  return result;
}

export async function getS3File(bucket, prefixfilename, section = 0) {
  const authHeaders = await getAuthHeaders();
  let response = await get({
    apiName,
    path: path + "get-s3-file",
    options: {
      headers: {
        ...authHeaders,
        bucket: bucket,
        prefixfilename: prefixfilename,
        section: `${section}`,
      },
    },
  }).response;

  const result = await response.body.json();
  return result;
}

export async function getS3FileList(bucket, prefix) {
  const authHeaders = await getAuthHeaders();
  let response = await get({
    apiName,
    path: path + "get-s3-list",
    options: {
      headers: {
        ...authHeaders,
        bucket: bucket,
        prefix: prefix,
      },
    },
  }).response;

  const result = await response.body.json();
  return result;
}

export async function getZipFile(userName, dateTime, prefixList = []) {
  const authHeaders = await getAuthHeaders();
  let response = await get({
    apiName,
    path: path + "get-data",
    options: {
      headers: {
        ...authHeaders,
        type: "zip",
        prefix: prefixList,
        section: `${userName}_${dateTime}`,
      },
    },
  }).response;

  const result = await response.body.json();
  return result;
}
